import ListMixinController from "@/mixins/ListMixinController";

export default {
  mixins: [ListMixinController],
  props: {
    propFilters: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.loadingItems = true;
    this.getData();
  },
  watch: {
    totalItemsRegistered(value) {
      this.$emit("totalItemsChanged", { total: value });
    },
    // Filtros aplicados no pai -> recarrega do zero (page 1)
    propFilters: {
      deep: true,
      handler() {
        this.loadingItems = true;
        this.getData();
      },
    },
  },
  data() {
    return {
      columns: [
        {
          name: "ID",
          sortName: null,
          order: null,
        },
        {
          name: "Psicólogo",
          sortName: null,
          order: null,
        },
        {
          name: "Paciente",
          sortName: null,
          order: null,
        },
        {
          name: "Criado em",
          sortName: null,
          order: null,
        },
        {
          name: "Horário",
          sortName: "date",
          order: "DESC",
        },
        {
          name: "Valor",
          sortName: null,
          order: null,
        },
        {
          name: "Pagamento",
          sortName: null,
          order: null,
        },
        {
          name: "Recorrência",
          sortName: null,
          order: null,
        },
        {
          name: "Status",
          sortName: null,
          order: null,
        },
        {
          name: "NF",
          sortName: null,
          order: null,
        },
        // {
        //   name: "Atalho",
        //   sortName: null,
        //   order: null,
        // },
      ],
    };
  },
  methods: {
    prepareResponse(data) {
      return data.map((elem) => ({
        ...elem,
        paymentStatus:
          this.$appointmentsService.getAppointmentPaymentStatus(elem),
        statusObject: this.$appointmentsService.getAppointmentStatus(
          elem.status
        ),
      }));
    },
    fetchPromise() {
      // propFilters é lido fresco a cada fetch, então filtros removidos não ficam grudados
      let f = {
        ...this.filters,
        ...this.propFilters,
        orderBy: this.columns.filter(
          (r) => r.order != null && r.sortName != null
        ),
      };
      return this.$appointmentsService.list(f);
    },
    handleDetail(event, id) {
      event.preventDefault();
      const path = this.$router.resolve({
        path: `${this.$paths.appointments.detail}/${id}`,
      });
      window.open(path.href, "_blank");
    },
    
  },
};
